import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

import { Plugins, FilesystemDirectory, FilesystemEncoding } from '@capacitor/core';
import { BASE_URL } from '@/constants/constants';

const { Storage, Filesystem } = Plugins;
const rootUrl = BASE_URL;

export default {
    
    state: {
        shared_annotations: [],
    },

    mutations: {
        setSharedAnnotations(state, data) {
            Vue.set(state, 'shared_annotations', data);
            Storage.set({
                key: 'shared_annotations',
                value: JSON.stringify(data)
            });
        }
    },
 
    actions: {
        // Fetch
        async fetchSharedAnnotations({ state, commit, dispatch, rootState, getters }) {
            const sub = await getters.getActiveSubscription;
            if (sub && sub.id) {
                const headers = { 'Authorization': rootState.authorization };
                const response = await axios.get(`${rootUrl}/account/annotations/viewer/${sub.id}/`, { headers: headers });
                if (response.status === 200) {
                    commit('setSharedAnnotations', response.data);
                }
            }
        },
        // Get
        getSharedAnnotations({ commit, dispatch }) {
            Storage.get({ key: 'shared_annotations' }).then((response) => {
                let list = JSON.parse(response.value);
                if (list && list.length) {
                    commit('setSharedAnnotations', list);
                }
            });
            dispatch('fetchSharedAnnotations');
        },
        // Clear
        clearSharedAnnotations({ commit, dispatch }) {
            commit('setSharedAnnotations', []);
        },
    },

    getters: {
        
        sharedAnnotations: (state) => {
            return state.shared_annotations;
        },

        sharedAnnotation: (state) => (id) => {
            return state.shared_annotations.find(x => x.id === id);
        }
    },
};